import {pushga} from 'ga-utils';

export function eventMiddlewareForFE({
  onClick = e => {},
  eventObj = {},
  options = {},
}: IEventMiddlewareForFE): Function {
  return e => {
    const {eventCategory = '', eventAction = '', eventLabel = ''} = eventObj;
    if (eventObj && eventObj.eventCategory) {
      pushga({eventAction, eventCategory, eventLabel});
    }
    onClick(e);
  };
}

export interface IEventMiddlewareForFE {
  onClick: Function;
  eventObj: {eventCategory?: string; eventAction?: string; eventLabel?: string};
  options: {};
}
